import { currentBrand } from '../../../config'
import { amountToCreditsFormat, amountToCurrencyFormat } from '../../../utils/format'
import React from 'react'

type TCallPriceProps = {
	payRate: number
}

const CallPrice = ({ payRate }: TCallPriceProps) => {
	return (
		<span>
			{`${
				currentBrand.creditBased
					? amountToCreditsFormat(payRate, currentBrand.creditAmount)
					: amountToCurrencyFormat(payRate / 100)
			} ${currentBrand.creditBased ? 'credits' : '$'} per call`}
		</span>
	)
}

export default CallPrice
